import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getMandateImages, uploadMandateImage, updateMandateImage, deleteMandateImage } from '../api/mandateImages';

export function useMandateImages(mandateId: string) {
  return useQuery({
    queryKey: ['mandate-images', mandateId],
    queryFn: async () => {
      const result = await getMandateImages(mandateId);
      return result.data;
    },
    staleTime: 30000,
  });
}

export function useUploadMandateImage(mandateId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ file, category, caption }: { file: File; category: string; caption?: string }) =>
      uploadMandateImage(mandateId, file, category, caption),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['mandate-images', mandateId] }),
  });
}

export function useUpdateMandateImage(mandateId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ imageId, updates }: { imageId: string; updates: { category?: string; caption?: string; sort_order?: number } }) =>
      updateMandateImage(mandateId, imageId, updates),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['mandate-images', mandateId] }),
  });
}

export function useDeleteMandateImage(mandateId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (imageId: string) => deleteMandateImage(mandateId, imageId),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['mandate-images', mandateId] }),
  });
}
